import { api } from '../index';

const prefix = '/api/boxing/';

export function apiIndex() {
	return api.get(prefix + 'index');
}

export function apiSelectInvoice(param) {
	return api.post(prefix + 'selectInvoice', param);
}

export function apiSelectBoxInformation(param) {
	return api.post(prefix + 'selectBoxInformation', param);
}

export function apiInsertBox(param) {
	return api.post(prefix + 'insertBox', param);
}

export function apiDeleteBox(param) {
	return api.post(prefix + 'deleteBox', param);
}

export function apiDeleteBoxBatch(param) {
	return api.post(prefix + 'deleteBoxBatch', param);
}

export function apiAdjustBox(param) {
	return api.post(prefix + 'adjustBox', param);
}

export function apiSelectBoxItemList(param) {
	return api.post(prefix + 'selectBoxItemList', param);
}

export function apiUpdateBoxItemList(param) {
	// 서버의 박스 숫자값 검증 실패는 422(구버전 화면에서 axios 가 reject 해 Complete 가 중단되도록 일부러 4xx).
	// 이 요청에 한해 422 를 정상 응답으로 받아 화면이 data.result / data.msg 로 처리하게 한다.
	// (전역 인터셉터를 건드리지 않아 다른 API 의 422 처리에 영향이 없다)
	return api.post(prefix + 'updateBoxItemList', param, {
		validateStatus: status => (status >= 200 && status < 300) || status === 422,
	});
}

// #3165 jc 전용 : 체크한 N개 박스를 새 박스 1개로 통합한다.
// updateBoxItemList 와 같은 이유로 422(수량 범위 검증 실패)를 정상 응답으로 받아 화면이 msg 를 띄우게 한다.
export function apiMergeBoxes(param) {
	return api.post(prefix + 'mergeBoxes', param, {
		validateStatus: status => (status >= 200 && status < 300) || status === 422,
	});
}

export function apiClearBoxInformation(param) {
	return api.post(prefix + 'clearBoxInformation', param);
}

export function apiSelectInvoiceItemList(invoice_no, for_boxing) {
	return api.get(prefix + 'selectInvoiceItemList', { params: { invoice_no, for_boxing } });
}

export function apiSelectWarehouseMemoList(param) {
	return api.post(prefix + 'selectWarehouseMemoList', param);
}

export function apiSetWarehouseMemo(param) {
	return api.post(prefix + 'setWarehouseMemo', param);
}

export function apiDeleteWarehouseMemoBatch(param) {
	return api.post(prefix + 'deleteWarehouseMemoBatch', param);
}

export function apiSelectInvoicePalletLabel(invoice_no) {
	return api.get(prefix + 'selectInvoicePalletLabel', { params: { invoice_no } });
}

export function apiSaveInvoicePalletLabel(param) {
	return api.post(prefix + 'saveInvoicePalletLabel', param);
}

export function apiSelectBoxSummaryByInvoice(invoice_no) {
	return api.get(prefix + 'selectBoxSummaryByInvoice', { params: { invoice_no } });
}

export function apiSelectReturnBoxList(param) {
	return api.post(prefix + 'selectReturnBoxList', param);
}

export function apiSelectReturnBoxCount(param) {
	return api.post(prefix + 'selectReturnBoxCount', param);
}

export function apiInsertReturnBox(param) {
	return api.post(prefix + 'insertReturnBox', param);
}

export function apiUpdateReturnBox(param) {
	return api.post(prefix + 'updateReturnBox', param);
}

export function apiDeleteReturnBox(param) {
	return api.post(prefix + 'deleteReturnBox', param);
}

export function apiUpdateReturnBoxItemBatch(param) {
	return api.post(prefix + 'updateReturnBoxItemBatch', param);
}

export function apiArrangeReturnBoxOrder(param) {
	return api.post(prefix + 'arrangeReturnBoxOrder', param);
}
